'use client'

import type { CSSProperties } from 'react'
import { cx } from './utils/cx'

export type ToggleOption = string | { value: string; label: string; count?: number | string }

interface ToggleGroupProps {
  options: ToggleOption[]
  value?: string
  onChange?: (value: string) => void
  size?: 'sm'
  className?: string
  style?: CSSProperties
}

export function ToggleGroup({ options, value, onChange, size, className, style }: ToggleGroupProps) {
  return (
    <div className={cx('st-seg', size, className)} style={style}>
      {options.map((o) => {
        const k = typeof o === 'string' ? o : o.value
        const label = typeof o === 'string' ? o : o.label
        const count = typeof o === 'object' ? o.count : undefined
        return (
          <button key={k} type="button" className={value === k ? 'on' : ''} onClick={() => onChange?.(k)}>
            {label}
            {count != null && (
              <span className="st-pip" style={{ marginLeft: 6 }}>
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
